import { render, staticRenderFns } from "./deletedStatus.vue?vue&type=template&id=cc67210a&"
import script from "./deletedStatus.vue?vue&type=script&lang=js&"
export * from "./deletedStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/system/deletedStatus.vue"
export default component.exports